/**
 * The file name an export's `Content-Disposition` carries (docs/specs/export.md EX24), **as the server sent it**:
 * the server slugs and dates the name, so the client re-slugs nothing and trims nothing. `filename*` (RFC 5987) wins
 * over `filename` where both are present, as a browser's own download does.
 *
 * Null when there is no header or it names no file — the header is hidden from a script on another origin unless CORS
 * exposes it (EX23), and the caller then falls back to a name of its own.
 *
 * Its own module with no imports, so `node --test` can run it.
 */
export function fileNameFromDisposition(header: string | null): string | null {
  if (!header) return null;

  const star = /(?:^|;)\s*filename\*\s*=\s*([^;]+)/i.exec(header);
  if (star) {
    const value = star[1].trim();
    const quote = value.indexOf("''");
    const encoded = quote >= 0 ? value.slice(quote + 2) : value;
    try {
      const decoded = decodeURIComponent(encoded.replace(/^"|"$/g, ''));
      if (decoded) return decoded;
    } catch {
      // A malformed filename* falls through to filename.
    }
  }

  const plain = /(?:^|;)\s*filename\s*=\s*("(?:[^"\\]|\\.)*"|[^;]*)/i.exec(header);
  if (!plain) return null;
  const raw = plain[1].trim();
  const name = raw.startsWith('"') ? raw.slice(1, -1).replace(/\\(.)/g, '$1') : raw;
  return name || null;
}
